import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ListDisplay,
  ContentDisplay,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IAbout } from '@/modules/catalog/services/variable-income';

interface Props {
  about: IAbout;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  props: {
    about: null
  },
  setup(__props: any) {

const props = __props as {
  about: IAbout;
}



const router = useRouter();

const title = computed(() => {
  return props.about?.title || '-';
});

const riskColor = computed(() => {
  return NebraskaColors.riskHigh;
});

const riskProfileButtonLabel = computed(() => {
  return props.about.riskProfile?.buttonLabel || 'Perfil';
});

const riskProfileTitle = computed(() => {
  return props.about.riskProfile?.portfolioRiskProfile.formatted || '';
});

const riskProfileDescription = computed(() => {
  return props.about.riskProfile?.portfolioRiskProfile.description || '';
});

const riskProfileHref = computed(() => {
  return router.resolve({ name: 'myprofile', query: { goBack: 'true' } }).href;
});

return { __sfc: true,props, router, title, riskColor, riskProfileButtonLabel, riskProfileTitle, riskProfileDescription, riskProfileHref, ListDisplay, ContentDisplay, Heading, BaseText, NebraskaColors }
}

})